<template>
  <el-row :gutter="10">
    <el-col :span="12">
      <el-input v-model.trim="code" @blur="$emit('blur')" maxlength="6" placeholder="请输入验证码"></el-input>
    </el-col>
    <el-col :span="12">
      <img :src="imgData" class="verify-code-img" alt="" @click="refreshCodeImg">
    </el-col>
  </el-row>
</template>

<script>
  export default {
    name: 'VerifyImage',
    props: {
      refresh: Boolean,
      formKey: String,
    },
    model: {
      prop: 'refresh',
      event: 'refreshOk',
    },
    data() {
      return {
        code: '',
        imgData: '',
      }
    },
    watch: {
      formKey(nv, ov) {
        if (nv !== '') {
          this.refreshCodeImg()
        }
      },
      code(nv, ov) {
        this.$emit('change', nv)
      },
      refresh(nv, ov) {
        if (nv) {
          this.code = ''
          this.refreshCodeImg()
          this.$emit('refreshOk', false)
        }
      },
    },
    methods: {
      /**
       * 刷新验证码图片
       */
      refreshCodeImg() {
        if (this.formKey !== '') {
          this.$api.common.verifyCodeImg(this.formKey).then(res => {
              if (res.code === 0) {
                this.imgData = res.data
              }else{
                this.$message.error("加载验证码失败，" + res.msg)
              }
          })
        }
      },
    },
  }
</script>

<style scoped>
  .verify-code-img {
    height: 40px;
    width: 100%;
  }
</style>
